import type { TableProps } from '@risk-smart/themed-cloudscape-components/table';
import CSTable from '@risk-smart/themed-cloudscape-components/table';
import type { FC } from 'react';
import { forwardRef, useMemo, useRef } from 'react';

import style from './style.module.scss';
import { useColumnAutofit } from './useColumnAutofit';

const DEFAULT_MIN_COL_WIDTH = 50; // px

const Table: FC<TableProps> = forwardRef<TableProps.Ref, TableProps>(
  (props, ref) => {
    const normalizedColumns = useMemo(
      () =>
        (props.columnDefinitions ?? []).map((col) => ({
          ...col,
          // Apply a sensible default only when minWidth isn't provided
          minWidth: col.minWidth ?? DEFAULT_MIN_COL_WIDTH,
        })),
      [props.columnDefinitions]
    );

    // Excel-style: double-click a column border to auto-fit it to its content.
    // Only meaningful when columns are resizable.
    const rootRef = useRef<HTMLDivElement>(null);
    useColumnAutofit(rootRef, { enabled: Boolean(props.resizableColumns) });

    return (
      <div className={style.root} ref={rootRef}>
        <CSTable {...props} columnDefinitions={normalizedColumns} ref={ref} />
      </div>
    );
  }
);
Table.displayName = 'Table';

export default Table;
